/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import {useMutation, useQuery} from '@apollo/client';
// import {Divider, Typography} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LoadingProgress from '@material-ui/core/LinearProgress';
import {DialogProps} from 'packages/common-types/base-types';
import AutocompletePlayers from 'packages/common-ui/AutocompletePlayers';
import {GET_TOURNAMENT} from 'packages/graphql/v2/queries';
import {CREATE_GROUP} from 'packages/graphql/v2/mutations';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import useAppSelector from 'packages/hooks/use-app-selector';
import {selectPlayersToGroup, clearGroup} from 'redux/features/app-slice';
import useCommonStyles from 'packages/common-utils/common-styles';
import useStyles from 'packages/admin/groups/groups.styles';
// import MemberList from 'packages/admin/groups/MemberList';
import {
  Tournament,
  Member,
  Competitor,
  Group,
} from 'packages/common-types/schema-types';
import {
  GetTournamentData,
  GetTournamentVars,
} from 'packages/common-types/queries-types';
import Swal from 'sweetalert2';

type CreateGroupVars = {
  members: Member[];
  tournamentId: string;
};
type CreateGroupData = {
  createGroup: Competitor;
};

type Props = DialogProps & {
  selectedTournament: Tournament;
  dataGroup: Group[];
  refetchGroup: () => void;
};

const CreateGroup = (props: Props) => {
  const {selectedTournament, toggle, modalOpen, dataGroup, refetchGroup} =
    props;
  const classes = useStyles();
  const common = useCommonStyles();
  const playersToGroup = useAppSelector(selectPlayersToGroup);
  const dispatch = useAppDispatch();
  const {data: dataTournament} = useQuery<GetTournamentData, GetTournamentVars>(
    GET_TOURNAMENT,
    {
      variables: {
        tournamentId: selectedTournament?._id,
      },
    }
  );
  const [createGroup, {loading}] = useMutation<
    CreateGroupData,
    CreateGroupVars
  >(CREATE_GROUP);

  const handleCreateGroup = async () => {
    if (selectedTournament) {
      const {
        _id: tournamentId,
        conditions: {modalityGame},
      } = selectedTournament;

      if (
        !playersToGroup ||
        !playersToGroup?.length ||
        playersToGroup?.length < 2
      )
        return;

      if (modalityGame === 'Parejas' && playersToGroup?.length > 2) return;

      const members: Member[] = playersToGroup.map(
        ({fullName, clubId, phoneNumber, address: {country, state, city}}) => ({
          fullName,
          clubId,
          address: {
            country,
            state,
            city,
          },
          phoneNumber,
        })
      );
      try {
        await createGroup({
          variables: {
            tournamentId,
            members,
          },
        });
        dispatch(clearGroup());
        refetchGroup();
        toggle();
        Swal.fire({
          title: 'Success',
          text: 'Grupo creado correctamente.',
          icon: 'success',
        });
      } catch (error) {
        console.error('ERROR => ', error);
        Swal.fire({
          title: 'Error',
          text: 'Hubo un error al crear el grupo.',
          icon: 'error',
        });
        dispatch(clearGroup());
      }
    }
  };

  const players = dataTournament?.getTournament?.inscriptions
    .filter(({user: {fullName}}) => {
      return !dataGroup?.some(({members}) => {
        return members.some(
          ({fullName: participantFullName}) => fullName === participantFullName
        );
      });
    })
    .map(({user}) => user);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={modalOpen}
      onClose={toggle}
      aria-labelledby="create-group-dialog"
    >
      <DialogTitle id="create-group-dialo">
        <h1 className={common.dialog_title}>Crear un grupo</h1>
        <span className={common.dialog_subtitle}>
          Busca entre los usuarios registrados para crear un nuevo grupo
        </span>
      </DialogTitle>
      <DialogContent style={{position: 'relative'}} dividers>
        {loading && <LoadingProgress />}
        <div className={classes.create_group_container}>
          <AutocompletePlayers dataPlayers={players} />
        </div>
      </DialogContent>
      <DialogActions style={{margin: 8, marginRight: 16}}>
        <Button
          variant="outlined"
          disableElevation
          className={common.custom_button}
          onClick={toggle}
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          disabled={!selectedTournament}
          disableElevation
          className={common.custom_button}
          onClick={handleCreateGroup}
          color="primary"
        >
          Crear grupo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateGroup;
